var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDataTraffic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Data_Traffic",
    "data-name": "Data Traffic",
    className: "cls-1",
    d: "M950,300H825V550a75,75,0,0,1-75,75H600a75,75,0,0,1-75-75V300H400L631.09,68.09a62.336,62.336,0,0,1,87.82,0ZM600,700L368.91,931.91a62.337,62.337,0,0,1-87.82,0L50,700H175V450a75,75,0,0,1,75-75H400a75,75,0,0,1,75,75V700H600Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDataTraffic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DataTraffic.62cd0ed7.svg";
export { ForwardRef as ReactComponent };